if(document.querySelectorAll('.cookies-disclaimer').length){
  const setCookieDisclaimerHeight = (section) => {
    if(!section.classList.contains('hidden')){
      const height = section.querySelector('div').offsetHeight;
      document.querySelector('body').style.paddingBottom = height + 'px';
    }else{
      document.querySelector('body').style.paddingBottom = null;
    }
  }

  if (!localStorage.getItem('cookie_disclaimer')) {
    const section = document.querySelector('.cookies-disclaimer');
    section.classList.remove('hidden');

    setCookieDisclaimerHeight(section);

    window.addEventListener('resize', () => {
      setCookieDisclaimerHeight(section);
    });
  }

  document.querySelector('.cookies-disclaimer-close').addEventListener('click', function(event){
    event.preventDefault();
    const section = document.querySelector('.cookies-disclaimer');
    section.classList.add('hidden');
    localStorage.setItem('cookie_disclaimer', true);
    setCookieDisclaimerHeight(section);
  });
}